const checkScroller = (inner) => {
  inner.classList.toggle('scroller', inner.offsetWidth > window.innerWidth);
};

const setActiveCard = (inner, cards, index) => {
  const maxIndex = cards.length - 1;
  const nextIndex = Math.max(0, Math.min(index, maxIndex));

  cards.forEach((card, cardIndex) => {
    card.classList.toggle('active', cardIndex === nextIndex);
  });

  // eslint-disable-next-line no-param-reassign
  inner.dataset.active = String(nextIndex);
};

const initCardInteractions = (block, inner, cards) => {
  let touchStartX = null;
  const swipeThreshold = 40;

  cards.forEach((card, index) => {
    card.addEventListener('mouseenter', () => {
      setActiveCard(inner, cards, index);
    });

    card.addEventListener('click', () => {
      setActiveCard(inner, cards, index);
    });
  });

  block.addEventListener(
    'touchstart',
    (event) => {
      if (!event.changedTouches || event.changedTouches.length === 0) {
        return;
      }

      touchStartX = event.changedTouches[0].clientX;
    },
    { passive: true },
  );

  block.addEventListener(
    'touchend',
    (event) => {
      if (
        touchStartX === null
        || !event.changedTouches
        || event.changedTouches.length === 0
      ) {
        touchStartX = null;
        return;
      }

      const touchEndX = event.changedTouches[0].clientX;
      const deltaX = touchEndX - touchStartX;
      const activeIndex = Number.parseInt(inner.dataset.active, 10) || 0;

      if (Math.abs(deltaX) < swipeThreshold) {
        touchStartX = null;
        return;
      }

      if (deltaX < 0) {
        setActiveCard(inner, cards, activeIndex + 1);
      } else {
        setActiveCard(inner, cards, activeIndex - 1);
      }

      touchStartX = null;
    },
    { passive: true },
  );
};

const initHeroCardHover = () => {
  const blocks = document.querySelectorAll('.hero-card-hover');

  blocks.forEach((block) => {
    const inner = block.querySelector('.hero-card-hover__inner');
    const cards = block.querySelectorAll('.hero-card-hover__card');

    checkScroller(inner);
    window.addEventListener('resize', () => checkScroller(inner));
    initCardInteractions(block, inner, cards);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction(
      'render_block_preview/type=azds/hero-card-hover',
      () => {
        initHeroCardHover();
      },
    );
  } else {
    initHeroCardHover();
  }
});
